import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Nav.css';

class Nav extends Component {
	render() {
		return (
			<div id="nav">
				<div>
					<Link to="/">Index</Link>
					{this.props.title ? " / " + this.props.title : null}
				</div>
				{this.props.userActions}
			</div>
		);
	}
}

export default Nav;


// WEBPACK FOOTER //
// ./src/Nav.js